interface CsrfResult {
  readonly csrfToken: string;
}

async function freshCsrfToken(): Promise<string> {
  const response = await fetch('/api/auth/csrf', {
    method: 'GET',
    credentials: 'same-origin',
  });
  if (!response.ok) throw new Error('csrf-unavailable');
  const result = (await response.json()) as CsrfResult;
  return result.csrfToken;
}

export async function changePassword(input: {
  readonly currentPassword: string;
  readonly totpCode: string;
  readonly newPassword: string;
}): Promise<void> {
  const csrfToken = await freshCsrfToken();
  const response = await fetch('/api/auth/password-change', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify(input),
  });
  if (!response.ok) throw new Error('password-change-rejected');
}
